import { ofType } from 'redux-observable'
import {
  SUBSCRIPTION_LIST_GET,
} from '../actionType'
import { catchError, switchMap, map } from 'rxjs/operators'
import { of } from 'rxjs'
import {
  subscriptionListGetFAction,
  subscriptionListGetRAction

} from '../action/subscriptionAction'
import subscriptionService from '../../services/subscriptionService'

export const getSubscriptionEpic = (action$ : any) => {
  return action$.pipe(
    ofType(SUBSCRIPTION_LIST_GET),
    switchMap((action : any) => {
      return subscriptionService.getSubscription(action.payload).pipe(
        map((res :any) => {
          // console.log(res,'response in shipTypeEpic')
          const { content, total_page, total_element } = res.data
          // console.log(content,'content in ship type')
          // console.log(total_page,'total page in ship type')
          // console.log(total_element,'total element in ship type')
          return subscriptionListGetFAction({ content, total_page, total_element })
        }),
        catchError((err : any) => of(subscriptionListGetRAction(err)))
      )
    })
  )
}